var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.itemValues,"label":"Version","solo":"","hide-details":""},on:{"change":_vm.changeSelected},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})}
var staticRenderFns = []

export { render, staticRenderFns }